import React from "react";
import { cn } from "@/lib/utils";

interface FieldWrapperProps {
  label: string;
  required?: boolean;
  error?: string;
  className?: string;
  children: React.ReactNode;
  cssLabel?:string;
}

export const FieldWrapper = ({
  label,
  required,
  error,
  className,
  children,
  cssLabel,
}: FieldWrapperProps) => {
  return (
    <div className={`flex flex-col gap-2 ${className ?? ""}`}>
      <div className="flex items-center gap-1">
        <span className={cn("text-sm leading-5 tracking-[-0.01em] text-black ", cssLabel)}>{label}</span>
        {required && <span className="text-sm leading-5 text-[#CB3A31]">*</span>}
      </div>
      {children}
      {error && (
        <p className="text-sm leading-5 text-[#CB3A31]" role="alert">
          {error}
        </p>
      )}
    </div>
  );
};
